import {h} from 'vue'
import { LlIcon } from '@ll-plus/components'
import { notification } from 'ant-design-vue'

type INotificationInfo = 'success' | 'info' | 'warning' | 'error'|'warn'|'open'
export interface ILlNotification{
  success: (config) => void
  info: (config) => void
  warning: (config) => void
  error: (config) => void
  warn: (config) => void
  open: (config) => void
}

const notificationInfo: INotificationInfo[] = ['success', 'info', 'warning', 'error','warn','open']

export const llNotification = {} as ILlNotification

notificationInfo.map(key=>{
  if(Object.keys(notification).includes(key)){
    llNotification[key] = (config)=>{
      notification[key]({
        ...config,
        icon: config.iconProp?h(LlIcon,{
          ...config.iconProp
        }):config.icon
      })
    }
  }
})

